// Module
var code = `<div ng-transclude="wrapper"></div>
<div ng-transclude="body"></div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/tooltip/tooltip.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;